import { TableWrapper } from "../../common/SideBySideTableLayout/SideBySideTableLayout.styles";
import Table from "../Table/Table";
import { FC, forwardRef } from "react";
import { useGetRawProducts } from "../../services/rawProd/rawProd.service";
import { RawProd } from "../../services/rawProd/rawProd.types";
import { RowSelectedEvent } from "ag-grid-community";
import { TableProps } from "../Table/Table.types";
import { useFetchErrorToast } from "../../utils/useFetchErrorToasts/useFetchErrorToast";

interface RawProductSelectTableProps
    extends TableProps
{
  title: string | undefined;
  onSelected: (event: RowSelectedEvent) => void;
}

const RawProductSelectTable: FC<RawProductSelectTableProps> = forwardRef((
    {
      title,
      onSelected,
      ...props
    },
    gridRef
) => {
  const { data: getRawProductsResponse, isError: getRawProductsErrors } = useGetRawProducts();
  const rawProducts: RawProd[] = getRawProductsResponse?.data || [];

  useFetchErrorToast([
    { isError: getRawProductsErrors, label: 'Error fetching Raw Products', id: 'getRawProductsError' }
  ]);

  return (
      <TableWrapper>
        <Table
            ref={gridRef}
            showHeader={title !== undefined}
            headerTitle={title}
            rowData={rawProducts}
            returnedRecords={rawProducts.length}
            rowSelection="single"
            onRowSelected={onSelected}
            columnDefs={[
              {
                width: 48,
                checkboxSelection: true,
                floatingFilter: false,
                sortable: false
              },
              { minWidth: 80, flex: 1, field: 'moaRawProdNo', headerName: 'Raw Product' },
              { minWidth: 80, flex: 2, field: 'moaRawProdDesc', headerName: 'Description', resizable: false }
            ]}
            {...props}
        />
      </TableWrapper>
  )
})

export default RawProductSelectTable;